var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout"},[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"container"},[_c('child')],1)])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c337ec48","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/layouts/large.vue
// module id = gmhD
// module chunks = 97